import axios from 'axios';
import { BASE_URL } from './apiconfig';
import { appendImpersonationParams } from './impersonationUtils';

export const getUsers = async (token: string | null, params:string) => {
  try {
    const queryString = appendImpersonationParams(params);
    const { data } = await axios.get(`${BASE_URL}/users?${queryString}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull user list. ", error);
    throw error;
  }
}

export const getUsersCount = async (token: string|null) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/users/count`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return data;
  } catch (error) {
    console.log("Failed to pull user list. ", error);
    throw error;
  }
}

export const getUserById = async (token: string | null, id: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/users/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return data;
  } catch (error) {
    console.log("Failed to pull user by id. ", error);
    throw error;
  }
}